<template>
	<div class="aboutCertificates">
		<my-header active="6" />
		<div class="main">
			<div class="container">
				<div class="current ">
					<p>当前位置：首页>资料下载</p>
				</div>
                <div class="warp">
                    <examination-sidebar />
                    <div class="sidebar-right">
                        <div class="title">
                            <h1>资料下载<span> / Document Download </span></h1>
                            <p>共{{ total }}套资料</p>
                        </div>
                        <div class="sou">
                            <!-- <p>已下载一套资料</p> -->
                            <p></p>
                            <div>
                                <el-input
                                    placeholder="请输入内容"
                                    style="width: 300px;"
                                    v-model="listQuery.name">
                                    <i slot="suffix" @click="getList" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </div>
                        </div>
                        <ul class="list">
                            <li v-for="(item, index) in list" :key="index">
                                <div class="box">
                                    <div class="left">
                                        <h1>{{item.name}}</h1>
                                        <p>共{{ item.files ? item.files.length : 0 }}个资料</p>
                                    </div>
                                    <div class="right">
                                        <el-button class="textBtn" v-if="index!=show" @click="open(index)" type="text">展开全部</el-button>
                                        <el-button class="textBtn" v-else @click="open(-1)" type="text">收起全部</el-button>
                                        <el-button class="btn" @click="downlaod(item.files)">下载全部</el-button>
                                    </div>
                                </div>
                                <el-collapse-transition>
                                    <ul class="list2" v-if="show==index">
                                        <li v-for="(v, i) in item.files" :key="i">
                                            <div class="block">
                                                <div class="left">
                                                    <p><span>{{i+1}}</span>{{v.fileName}}</p>
                                                </div>
                                                <div class="right">
                                                    <el-button class="btn" @click="downlaod([v])">下载资料</el-button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </el-collapse-transition>
                            </li>
                        </ul>
                        <p style="text-align: center;" v-if="!list.length">暂无数据</p>
                    </div>
                </div>
            </div>
            <my-footer />
        </div>   
    </div>
</template>

<script>
import { listAndFile } from '@/api/article'
export default {
	name: 'referenceMaterial',
	components: {

	},
	data(){
		return {
            listQuery: {
                pageNum: 1,
                pageSize: 999,
                type: 8,
                name: ''
            },
            total:0,
            value:null,
            list:[],
            show:null,
		}
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(){
            listAndFile(this.listQuery).then(res => {
                if(res.list){
                    this.list = res.list
                    this.total = res.total
                }
            })
        },
        downlaod(data){
            if(data && data.length){
                let i = 0
                var s = setInterval(() => {
                    if(i < data.length){
                        let item = data[i]
                        let a = document.createElement('a')
                        a.setAttribute('download', item.fileName)
                        a.setAttribute('target', '_blank')
                        a.setAttribute('href', item.fileUrl)
                        a.click()
                        i++
                    }else{
                        clearInterval(s)
                    }
                }, 50)
                
                
                // data.forEach((item, index) => {
                    

                    // let url = window.URL.createObjectURL(item.fileUrl)
                    // let link = document.createElement('a')
                    // link.style.display = 'none'
                    // link.href = url
                    // link.setAttribute('download', item.fileName)
                    // document.body.appendChild(link)
                    // link.click()
                    // window.URL.revokeObjectURL(url)
                    // document.body.removeChild(link)
                // })
            }else{
                this.$message.error('下载内容为空')
                return
            }
        },
        open(index){
            this.show = index
        }
    },
}
</script>

<style scoped>
/*按钮*/
.aboutCertificates >>> .btn{
    width: 120px;height: 35px;line-height: 35px;padding: 0;margin: 0;border:0;border-radius: 5px;color: #fff;font-size: 14px;
    background: -webkit-linear-gradient(#bf371e, #942424);
    background: -o-linear-gradient(#bf371e, #942424);
    background: -moz-linear-gradient(#bf371e, #942424);
    background: linear-gradient(#bf371e, #942424);margin-left: 20px;
}
.aboutCertificates >>> .btn:focus, .aboutCertificates >>> .btn:hover{color: #fff;}
.aboutCertificates >>> .btn:active{color: #fff;}
.aboutCertificates >>> .btn.is-disabled{background: #e7e7e7;color: #333;}
.aboutCertificates >>> .btn.is-disabled:hover{background: #e7e7e7;color: #333;}
.aboutCertificates >>> .btn+.btn{margin-left: 40px;}
.title{
    display: flex;
    justify-content: space-between;
}
.title p,.sou p {
    font-size: 12px;
    color: #999;
}
.sou{
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
}
.sou p{
    display: flex;
    align-items:flex-end;
}
.list>li{
    margin-bottom: 10px;
}
.list>li .box{
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: #F2F2F2;
}
.list>li .box h1{
    margin-bottom: 10px;
}
.list>li .box .right{
    display: flex;
    align-items:center;
}
.list>li .left h1{
    font-size: 18px;
    font-weight: bold;
}
.list>li .left p{
    font-size: 14px;
    color: #666;
}
.textBtn{
    color: #b82f20;
    text-decoration:underline;
}
.list2{
    padding: 0 20px;
}
.list2 li{
    border-bottom: 1px dashed #e6e6e6;
}
.list2 .block{
    display: flex;
    justify-content: space-between;
    height: 75px;
    line-height: 75px;
}
.block .left span{
    display: inline-block;
    width: 35px;
    height: 35px;
    border: 2px solid #b82f20;
    border-radius: 50%;
    text-align: center;
    line-height: 35px;
    justify-content: center;
    font-size: 18px;
    color: #b82f20;
    margin-right: 10px;
}
.list2{
    width: 960px;
    box-sizing: border-box;
}
.list2 .left{
    width: 85%;
}
.list2 .left p{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
}

</style>
